export default __webpack_public_path__ + "i18n/pl.f9b43565c8e8989b87e52fc1874d5bac.json";